import React from 'react'
import './Annoucement.css';

const Annoucement = () => {
  return (
    <div className="container">
        <div className="contain">
        Super Deal !, Free shipping after ordering.
        </div>
       </div> 
  )
}

export default Annoucement